export default __webpack_public_path__ + "static/eclipse1-2247cbf1f9e18d50d175019bc55379d7.png";